import { Link } from 'react-router-dom';
import { cn } from '@kainos/ui';
import type { ChatMessage as ChatMessageModel } from '../hooks/useAiChat';

export interface ChatMessageProps {
  message: ChatMessageModel;
  onNavigate?: () => void;
}

/** One bubble in the assistant thread: soft blue for AI, navy for the user. */
export function ChatMessage({ message, onNavigate }: ChatMessageProps) {
  if (message.from === 'user') {
    return (
      <div className="ml-auto max-w-[82%] rounded-xl bg-brand px-3.5 py-2.5">
        <p className="text-[13px] font-medium leading-[1.5] text-white">{message.text}</p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        'max-w-[88%] rounded-xl border border-primary-border bg-primary-soft px-3.5 py-3',
      )}
    >
      <p className="text-[13px] font-medium leading-[1.55] text-ink-strong">{message.text}</p>
      {message.link ? (
        <Link
          to={message.link.to}
          onClick={onNavigate}
          className="mt-2 inline-block text-[12.5px] font-bold text-primary hover:underline"
        >
          {message.link.label} →
        </Link>
      ) : null}
    </div>
  );
}
